export const CANAL = 'CANAL';
export const FORNECEDOR = 'FORNECEDOR';
export const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const REACT_APP_PAYMENT_ACCESS_TOKEN = process.env.REACT_APP_PAYMENT_ACCESS_TOKEN;
export const SERVIDOR_URL = process.env.REACT_APP_SERVIDOR || 'https://machine-v5-b7b9730aef63.herokuapp.com';
